export class WinnerIdInfo {
  winnerId: number;
  fanId: number;

  constructor(fanId: number, winnerId: number) {
    this.fanId = fanId;
    this.winnerId = winnerId;
  }
}
